const termsOfUse = (state) => state.termsOfUse;

export const termsOfServiceModalSelector = (state) => {
  {
    const termsOfUseState = termsOfUse(state);
    return termsOfUseState.termsOfServiceModal;
  }
};
